export default __webpack_public_path__ + "static/media/07.07923071.png";